'use strict';
import popup from 'jquery-popup-overlay';
import 'dropzone';
$(document).ready(function(){
	// Попап оценки часов
	$('#rate').popup({
		scrolllock: true
	});
	
	$('#dropzone').dropzone({ url: "/file/post" });
});